import { useTranslation } from 'react-i18next';
import React from 'react';
void React;
import publicHomepageContent from '../../content/publicHomepageContent';

export default function RobotServiceSection() {
  const { t } = useTranslation();
  const { serviceSection } = t('homepageContent', { returnObjects: true, defaultValue: publicHomepageContent });
  return (
    <section className="kr-section kr-service-section" aria-labelledby="service-heading">
      <div className="kr-shell">
        <div className="kr-section-head">
          <h2 id="service-heading" className="k-h2">{serviceSection.title}</h2>
        </div>
        <div className="kr-service-steps">
          {serviceSection.steps.map((s, idx) => (
            <div key={s.key} className="kr-service-step" role="article" aria-labelledby={`step-${s.key}`}>
              <div className="kr-step-index">{idx + 1}</div>
              <div className="kr-step-body">
                <h3 id={`step-${s.key}`} className="kr-step-title">{s.title}</h3>
                <p className="kr-step-text">{s.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
